module.exports = __webpack_public_path__ + "static/media/paperflite_logo.4bf1e6bc.svg";